<nav class="flex">
    <ol class="breadcrumb-wrapper flex-wrap flex items-center" *ngIf="dataSource?.length">
        <li *ngFor="let eachPath of dataSource; let last = last; let index = index"
            [ngClass]="last ? 'pointer-events-none' : 'cursor-pointer'">
            <!--  [queryParams]="index === 1 ? { search_box: cityName, refer: 'hotelinfo', type: '1', 'city': cityId } : {}"  -->
            <!-- [queryParamsHandling]="index === 1 ? 'merge' : ''" -->

            <ng-container *ngIf="!last">
                <a [href]="eachPath.Url" (click)="index === 1 ? navToPlp(eachPath.Url,$event,index) : null">
                    {{ eachPath.Name }}
                </a>
            </ng-container>
            <ng-container *ngIf="last">
                <span class=""> {{ eachPath.Name }} </span>
            </ng-container>
        </li>
    </ol>
</nav>
<!-- + `'&search_box:' + hotelName -->